/**
 * ResetPassword1.jsx
 * Tatalli Cloud — Şifre Sıfırlama Adım 1 (E-posta gönderme)
 * Layout: src/Layouts/Shared/_AuthLayout.jsx
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import AuthLayout from '../../Layouts/Shared/_AuthLayout';

const LEFT_FEATURES = [
  { ikon: 'fa-envelope-open-text', key: 'auth.reset.step1' },
  { ikon: 'fa-key',                key: 'auth.reset.step2' },
  { ikon: 'fa-lock',               key: 'auth.reset.step3' },
];

export default function ResetPassword1() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [email, setEmail]           = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [gonderildi, setGonderildi] = useState(false);
  const [hata, setHata]             = useState('');

  const handleGonder = async (e) => {
    if (e) e.preventDefault();
    setYukleniyor(true);
    setHata('');
    try {
      const ApiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${ApiUrl}/access/login/reset-password`, { email });
      const data = response.data;
      if (data?.isSucceed) {
        setGonderildi(true);
        setTimeout(() => navigate('/reset-password-2'), 1800);
      } else {
        const msg = data?.messages?.[0]?.message;
        setHata(msg || t('api.default.service.response.error'));
        setYukleniyor(false);
      }
    } catch {
      toast.error(t('api.default.service.response.error'));
      setYukleniyor(false);
    }
  };

  return (
    <AuthLayout
      titleKey="pages.reset-password-1.title"
      leftHeadlineKey="auth.reset.left.headline"
      leftSloganKey="header.slogan"
      leftDescKey="auth.reset.left.description"
      leftFeatures={LEFT_FEATURES}
    >
      <div className="auth-form-konteyner">
        {gonderildi ? (
          /* ── Gönderildi ekranı ── */
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{
              width: 64, height: 64, borderRadius: '50%',
              background: '#e6f4e6',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px',
            }}>
              <i className="fas fa-paper-plane" style={{ color: '#107c10', fontSize: 24 }} />
            </div>
            <h2 style={{ fontWeight: 700, color: '#013682', marginBottom: 10 }}>
              {t('pages.reset-password-1.sent.title')}
            </h2>
            <p style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.7 }}>
              {t('pages.reset-password-1.sent.description')}
            </p>
            <div className="yuklenici-cember" style={{ margin: '20px auto 0' }} />
          </div>
        ) : (
          /* ── Form ── */
          <>
            <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10 }}>
              <Link
                to="/portal/login"
                style={{ color: '#9ca3af', transition: 'color 0.15s', lineHeight: 1 }}
                onMouseOver={e => e.currentTarget.style.color = '#013682'}
                onMouseOut={e => e.currentTarget.style.color = '#9ca3af'}
              >
                <i className="fas fa-arrow-left" />
              </Link>
              <h2 className="auth-form-baslik" style={{ marginBottom: 0 }}>
                {t('pages.reset-password-1.header')}
              </h2>
            </div>
            <p className="auth-form-aciklama">
              {t('pages.reset-password-1.description')}
            </p>

            {hata && (
              <div className="auth-hata-kutusu">
                <i className="fas fa-exclamation-circle" />
                <span>{hata}</span>
              </div>
            )}

            <form onSubmit={handleGonder}>
              <div className="form-grubu">
                <label className="form-etiketi">
                  {t('pages.reset-password-1.form.label.email')}
                </label>
                <div className="form-giris-grubu">
                  <span className="form-giris-ek">
                    <i className="fas fa-envelope" style={{ fontSize: 14, color: '#6b7280' }} />
                  </span>
                  <input
                    type="email" className="form-girisi"
                    placeholder={t('pages.reset-password-1.form.placeholder.email')}
                    value={email} onChange={e => setEmail(e.target.value)}
                    required autoComplete="email"
                  />
                </div>
              </div>

              <button
                type="submit"
                className="dugme dugme-birincil dugme-buyuk dugme-tam-genislik"
                disabled={yukleniyor}
                style={{ justifyContent: 'center', marginTop: 8 }}
              >
                {yukleniyor ? (
                  <>
                    <div className="yuklenici-cember yuklenici-cember-beyaz"
                      style={{ width: 16, height: 16, borderWidth: 2 }} />
                    {t('common.please-wait')}
                  </>
                ) : (
                  <>
                    {t('pages.reset-password-1.form.button.send-otp')}
                    <i className="fas fa-paper-plane" style={{ fontSize: 13 }} />
                  </>
                )}
              </button>

              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <Link to="/portal/login" className="auth-link" style={{ fontSize: 13 }}>
                  <i className="fas fa-arrow-left" style={{ marginRight: 6 }} />
                  {t('pages.reset-password-1.form.label.go-back-login')}
                </Link>
              </div>
            </form>

            <div className="auth-alt-bilgi">
              <p>© {new Date().getFullYear()} {t('footer.copyright.company-name')}</p>
            </div>
          </>
        )}
      </div>
    </AuthLayout>
  );
}
